//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import stepTitle from "../StepTitle";
import { api, config } from '@/service';

export default {
    props: {
      data: {
          default: () => []
      },
      businessScenesType: {
          type: Boolean,
          default: false
      },
    },
    data() {
        /**
         * @method validatorIsXieHao 校验是否为携号
         */
        let validatorIsXieHao = (rule, value, callback, errorText) => {            
            if (this.phone == 1) return callback()      
            else {
                if(!value) callback(new Error(errorText))
                else callback()
            }
        }

        /**
         * @method validatorIsCZK 校验是否为儲值卡
         */
        let validatorIsCZK = (rule, value, callback, errorText) => {            
            if (this.phone == 1 || this.form.simType == 2) return callback()                    
            if(!value) callback(new Error(errorText))
            else callback()            
        }

        /**
         * @method validatorIsCZKNumber 校验是否为儲值卡
         */
        let validatorIsCZKNumber = (rule, value, callback, errorText) => {            
            if (this.phone == 1 || this.form.simType == 2) return callback()                    
            if(!value) callback(new Error('請填寫儲值卡ICCID號碼'))
            else {
                if(isNaN(value)) callback(new Error('您填寫的儲值卡ICCID號碼有誤'))
                else callback()
            }
        }
        
        /**
         * @method checkPhone 檢測手機號
         */
        let checkPhone = (rule, value, callback, errorText) => {            
            if(!this.phone) callback(new Error('請選擇上台方式'))
            else if(this.phone == 1 && !this.input[0]) callback(new Error('請選擇新的電話號碼'))
            else if(this.phone == 2 && !this.input[1]) callback(new Error('請輸入正確的携號電話號碼'))
            else if(!this.sim) callback(new Error('請選擇SIM卡類型'))
            else callback()
        }
        return {
            uploadUrl: `${config.baseUrl}${api.uploadPict}`,
            phone: '1', // 上台号码       
            sim: '2',
            input: [],
            isSelectMobile: false, //是否有选择过
            dialog: {
                show: false,
                data: [],
                page: 0
            },
            fileList: {
              simAttach: []  
            },
            list: {
                CNMobile: [
                    {name: '是', value: 1},
                    {name: '否', value: 2},
                ],
               simType: [
                   {name: '月費計劃', value: '2'},
                   {name: '儲值卡', value: '1'}                 
               ] 
            },
            form: {
                simType: '2',
                oldIccid: '',
                simAttach: '',
                CNMobile: 1, //2020年3月24日 默认值 是否为中国移动号码 1：中国移动号码 2：不是中国移动号码   当是中国移动号码的时候registerType需要改为3
                registerType: '1', //專人辦理時，新增的上台方式字段 type == 2
            },
            rules: {
                phone: [
                    { required: true, validator: checkPhone, trigger: 'change' }        
                ],
                simType: [
                    { required: true, validator: (rule, value, callback) => validatorIsXieHao(rule, value, callback, '請選擇你當前使用號碼類別'), trigger: 'blur' }        
                ],
                oldIccid: [
                    { required: true, validator: (rule, value, callback) => validatorIsCZKNumber(rule, value, callback), trigger: 'blur' },     
                ],
                simAttach: [
                    { required: true, validator: (rule, value, callback) => validatorIsCZK(rule, value, callback, '請上傳SIM卡圖片'), trigger: 'blur' }        
                ],
                CNMobile: [
                    { required: true, validator: (rule, value, callback) => validatorIsCZK(rule, value, callback, '請選擇號碼運營商'), trigger: 'blur' }        
                ],
            }
        }
    },
    created() {
        this.init()
    },
    watch: {
        'input': function(n, o) {            
            this.emitInput()
        }
    },
    methods: {
        setForm(target, value) {
            this.form[target] = value
            if(target == 'simAttach') this.fileList.simAttach = [{name: 'simAttach', url: value}]            
        },
        handleRadioChange(param) {
            if (param == 1) {
                this.$refs.wayForm.clearValidate()
                //月费计划
                this.$emit('now-useCard', param)
            } else {
                this.$refs.wayForm.validate('simType')
                //储值卡
                this.$emit('now-useCard', param)
            }
        },
        toPosition(dom) {
            let { offsetTop } = dom
            window.scroll(0, offsetTop)
        },
        /**
         * @method handleSuccess 文件上传成功相应
         * @param {String} target 需要处理form下对应的对象属性
         * @param {params} params 钩子返回的信息
         * @param {String} ref 对应的上传组件的ref,用于处理上传返回非1000的情况移除上传的图片
         */
        handleSuccess(target, params, ref) {
            if(params.returnCode == 1000) {
                let url = params.dataInfo.url;
                let _split = url.split('/');
                this.form[target] = url        
                this.fileList[target] = [{name: _split[_split.length - 1], url: url}]  
                this.$nextTick(() => this.$refs.wayForm.clearValidate(target))
            }else {
                this.$message({ customClass: this.$device, showClose: true, message: params.message, type: 'warning'});
                this.$refs[ref].clearFiles()
            }
        },
        handleRemove(target, params) {
            this.form[target] = ''
            this.fileList[target] = []
        },
        emitInput() {
            this.$emit('phone-change', this.input[this.phone - 1])
        },
        handleChange(params) {            
            this.$refs.wayForm.validate('registerType')
            this.$refs.wayForm.clearValidate('phone')
            this.$emit('registerType', params)
            this.emitInput()        
        },
        handleChangeBusinessScenes(params) {
            this.$refs.wayForm.validate('registerType')
            this.$refs.wayForm.clearValidate('phone')
            this.form.registerType = params
            // this.$emit('registerType', params)     
        },
        emitSIMChange(params) {            
            this.$emit('sim-change', params)
        },
        CNMobileChange(params) {
            this.$emit('cnmobile-change', params)
        },
        handleClick(params) {       
            this.input[0] = params
            this.phone = '1'            
            this.dialog.show = false
            this.emitInput()
        },
        toggle() {
            this.dialog.show = !this.dialog.show
            if(this.dialog.show && !this.dialog.data.length) this.getPhoneList()
        },
        getPhoneList() {
            this.dialog.page += 1
            this.dialog.data = []
            this.$http('phoneBoss', {
                type: 1,
                pageNumber: this.dialog.page,
                pageSize: this.$device === 'pc' ? 25 : 10                
            }).then(res=>{
                if(res.returnCode == '1000') this.dialog.data = res.records                
            })
        },
        init() {        
            let { registerType } = this.data
            if(registerType.length) registerType.forEach(() => this.input.push(''))            
        },       
        getForm() {
            let temp;
            this.$refs.wayForm.validate(async (valid, object) => {
                if (valid) {
                    let { simType, oldIccid, simAttach } = this.form
                    let tregisterType = this.phone
                    if (simType == 1) {
                        //选择了储值卡
                        tregisterType = this.form.CNMobile == 1 ? 3 : this.phone
                    }
                    if (tregisterType == 1) {
                        //新號碼上台的時候，不傳儲值卡信息
                        oldIccid = ''
                        simType = 2
                    }
                    temp = {
                        registerType: tregisterType,
                        transactType: this.sim,
                        phoneNo: this.input[this.phone - 1],
                        simType,
                        oldIccid,
                        simAttach
                    }
                }
                else {                
                    for(let i in object) {
                        let target = this.$refs[i];                        
                        if(target) {
                            this.toPosition(target.$el)
                            break;
                        }
                    }
                    temp = '上台信息有誤'
                }
            })
            return temp
        }
    },
    components: {
        stepTitle
    }
}
